import { type FC } from "react";
import "pouchdb-browser";
import { BrowserRouter, Routes, Route, Link } from "react-router";
import * as uuid from "uuid";

import { useSyncStatuses } from "./repl_status";
import { Scanner } from "./Scanner";
import { usePwaStatus } from "./usePwaStatus";
import { ItemList } from "./pages/ItemList";
import { TemplateList } from "./pages/TemplateList";
import { ReplConfig } from "./pages/ReplConfig";
import { Item } from "./pages/ItemPage";
import { ScannerTestPage } from "./pages/ScannerTestPage";
import { DataErrors } from "./pages/DataErrors";
import { ConflictsPage } from "./pages/ConflictsPage";
import { IconLibraryPage } from "./pages/IconLibraryPage";
import { LabelPreview } from "./pages/LabelPreview";

const App:FC = () => {
  const syncStatuses = useSyncStatuses();
  const multiTarget = syncStatuses.length > 1;
  const { isStandalone, updateWaiting, applyUpdate } = usePwaStatus();
  return (
    <div style={{display: "flex", flexDirection: "column", height: "100vh", width: "100vw"}}>
      <div style={{display: "flex", flexDirection: "column", flexGrow: "1", flexShrink: "1", overflowY: "auto"}}>
        <Scanner>
          <BrowserRouter>
            <div style={{backgroundColor: "white", padding: "3px", borderBottom: "1px solid black"}}>
              <Link to="/">list</Link>
              |
              <Link to="/templates">templates</Link>
              |
              <Link to="/config">config</Link>
              |
              <Link to="/scanner">scanner</Link>
              |
              <Link to="/errors">errors</Link>
              |
              <Link to="/conflicts">conflicts</Link>
              |
              <Link to="/icons">icons</Link>
              |
              <Link to="/labels">labels</Link>
              |
              <Link to={`/items/item:${uuid.v7()}`}>new</Link>
            </div>
            <Routes>
              <Route index element={<ItemList />} />
              <Route path="templates" element={<TemplateList />} />
              <Route path="config" element={<ReplConfig />} />
              <Route path="items/:id" element={<Item />} />
              <Route path="scanner" element={<ScannerTestPage />} />
              <Route path="errors" element={<DataErrors />} />
              <Route path="conflicts" element={<ConflictsPage />} />
              <Route path="icons" element={<IconLibraryPage />} />
              <Route path="labels" element={<LabelPreview />} />
            </Routes>
          </BrowserRouter>
        </Scanner>
      </div>
      <div style={{backgroundColor: "white", padding: "3px", borderTop: "1px solid black", display: "flex", gap: "12px", flexWrap: "wrap", alignItems: "center"}}>
        {isStandalone && <span style={{fontSize: "small", background: "#2563eb", color: "white", borderRadius: "4px", padding: "0 5px"}}>PWA</span>}
        {updateWaiting && (
          <span style={{fontSize: "small"}}>
            Update available{" "}
            <button type="button" onClick={applyUpdate} style={{fontSize: "small"}}>Reload</button>
          </span>
        )}
        {syncStatuses.length === 0
          ? <span style={{color: "#888"}}>no sync targets</span>
          : syncStatuses.map(e => (
              <span key={e.name}>
                {multiTarget && <>{e.name}:{" "}</>}
                {e.status}
              </span>
            ))
        }
      </div>
    </div>
  );
};

export default App;
